import React, { Component, Fragment } from 'react'

import {
    GlobalStyle,
    Page,
    TopMenuBorder,
    BottomMenuBorder,
    PageBorder,
    PrintHeader,
    Grid,
    ActionButtons,
    ActionButton,
    MonoKioskDate,
} from './style'

import PrintKiosk from './PrintKiosk'
import MenuKiosk from '../KioskView/Kiosk/MenuKiosk'
import Settings from 'settings'
import NoDataSegment from '../NoDataSegment/NoDataSegment'
import { getLanguage } from '../../utils/Locale'
import moment from 'moment'

class PrintView extends Component {
    _elements = new Map()

    state = {
        zoom: this.props.zoom,
        orientation: this.props.orientation,
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.items.kiosks || !nextProps.items.kiosks) {
            return
        }
        if (this.props.zoom !== nextProps.zoom) {
            this.setState({ zoom: nextProps.zoom })
        }
        if (this.state.orientation !== nextProps.orientation) {
            this.setState({ orientation: nextProps.orientation })
        }
    }

    setZoom = factor => {
        const zoom = parseFloat(this.state.zoom) + parseFloat(factor)
        this.setState({ zoom })
    }

    setOrientation = orientation => {
        this.setState({ orientation })
    }

    render() {
        if (!this.props.items || this.props.items.length === 0) {
            return (
                <NoDataSegment message="There is not enough data to show the menu." />
            )
        }

        const { title, dataSource, isAdmin, language } = this.props
        const headerTitle =
            title || Settings.translations[getLanguage(language)].today

        let content = null
        let isMonoKiosk
        if (this.props.menu) {
            content = (
                <MenuKiosk
                    items={this.props.items.menus[this.props.menu]}
                    concept={this.props.concept}
                    menu={this.props.menu}
                    zoom={this.state.zoom}
                    orientation={this.props.orientation}
                    hideMenuPrice={this.props.hideMenuPrice}
                    hideRecipePoints={this.props.hideRecipePoints}
                    hideLabels={this.props.hideLabels}
                    dataSource={dataSource}
                    print
                />
            )
        } else {
            if (!this.props.items.kiosks) {
                return null
            }

            isMonoKiosk = this.props.items.kiosks.length === 1

            let centered = false

            const containsRecipePoints = this.props.items.kiosks.find((kiosk) => kiosk.items.find((_) => _.price_point))
            const containsPrice = this.props.items.kiosks.find((kiosk) => kiosk.items.find((_) => _.price_currency || _.price))

            if (containsPrice && containsRecipePoints) {
                if (this.props.hideMenuPrice && this.props.hideRecipePoints) centered = true
            } else if (containsPrice) {
                if (this.props.hideMenuPrice) centered = true
            } else if (containsRecipePoints) {
                if (this.props.hideRecipePoints) centered = true
            } else {
                centered = true
            }

            content = this.props.items.kiosks.map((kiosk, index) => (
                <PrintKiosk
                    key={index}
                    ref={r => this._elements.set(index, r)}
                    name={kiosk.name}
                    items={kiosk.items}
                    concept={this.props.concept}
                    menu={this.props.menu}
                    isMonoKiosk={isMonoKiosk}
                    zoom={this.state.zoom}
                    kioskPicture={kiosk.kioskPicture}
                    useCommercialName={this.props.useCommercialName}
                    hideMenuPrice={this.props.hideMenuPrice}
                    hideRecipePoints={this.props.hideRecipePoints}
                    hideEnergyKcal={this.props.hideEnergyKcal}
                    showEnergyKcalByPortion={this.props.showEnergyKcalByPortion}
                    hideLabels={this.props.hideLabels}
                    hideIntolerences={this.props.hideIntolerences}
                    dataSource={dataSource}
                    isAdmin={this.props.isAdmin}
                    centered={centered}
                    currency={this.props.currency}
                />
            ))
        }

        return (
            <Page
                size={this.props.size}
                orientation={this.state.orientation}
                centered={this.props.isAdmin}
                style={{marginTop: '2mm'}}
            >
                {this.props.menu ? (
                    <Fragment>
                        <TopMenuBorder />
                        <BottomMenuBorder />
                        <PageBorder fullSize={true} side="left" />
                        <PageBorder fullSize={true} side="right" />
                        <Grid
                            size={this.props.size}
                            orientation={this.state.orientation}
                            isMonoKiosk={isMonoKiosk}
                            ref={r => (this.grid = r)}
                        >
                            {content}
                        </Grid>
                    </Fragment>
                ) : (
                    <Fragment>
                        {isMonoKiosk && (
                            <>
                                {this.props.showDate && (
                                        <MonoKioskDate>{`${moment(this.props.items.date)
                                            .locale(getLanguage(language))
                                            .format('LL')}`}</MonoKioskDate>
                                    )}
                                <TopMenuBorder />
                            </>
                        )}
                        <BottomMenuBorder />
                        <PageBorder fullSize={isMonoKiosk} side="left" />
                        <PageBorder fullSize={isMonoKiosk} side="right" />
                        {!isMonoKiosk && (
                            <PrintHeader
                                size={this.props.size}
                                showDate={this.props.showDate}
                            >
                                <img
                                    src={`img/concept/${this.props.concept}/logo.png?_=9edb01b`}
                                    alt={this.props.concept}
                                />
                                <h1>
                                    {this.props.showDate && (
                                        <small>{`${moment(this.props.items.date)
                                            .locale(getLanguage(language))
                                            .format('LL')}`}</small>
                                    )}
                                    {headerTitle}
                                </h1>
                            </PrintHeader>
                        )}
                        <Grid
                            size={this.props.size}
                            orientation={this.state.orientation}
                            isMonoKiosk={isMonoKiosk}
                            ref={r => (this.grid = r)}
                        >
                            {content}
                        </Grid>
                    </Fragment>
                )}
                <GlobalStyle />
                {!isAdmin && (
                    <ActionButtons>
                        <div>
                            <ActionButton onClick={() => this.setZoom(-0.05)}>
                                -
                            </ActionButton>
                            <ActionButton onClick={() => this.setZoom(0.05)}>
                                +
                            </ActionButton>
                        </div>
                        <ActionButton
                            onClick={() => this.setOrientation('portrait')}
                        >
                            PORTRAIT
                        </ActionButton>
                        <ActionButton
                            onClick={() => this.setOrientation('landscape')}
                        >
                            LANDSCAPE
                        </ActionButton>
                        <ActionButton onClick={() => window.print()}>
                            PRINT
                        </ActionButton>
                    </ActionButtons>
                )}
            </Page>
        )
    }
}

export default PrintView
